import { call, type CallEffect } from 'redux-saga/effects';

import type { ExtractReturnType } from '@pressreader/types';

export function* callApi<FN extends (...args: any[]) => Promise<unknown>>(
    fn: FN,
    ...args: Parameters<FN>
): Generator<CallEffect, ExtractReturnType<FN>, ExtractReturnType<FN>> {
    return yield call(fn, ...args);
}
